module.exports = __webpack_public_path__ + "assets/img/KeyReport_005.d2e79cf4-ps.jpg";